import { Component, Input, OnInit } from '@angular/core';
import { SkuGroups } from 'src/models/History';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  @Input() products: SkuGroups[] = [];
  @Input() displayedColumns: string[] = ['name', 'packSize', 'quantity', 'sku'];
  @Input() displayMode: 'table' | 'list' = 'list';
  showProductImage = false;
  currentProductImageUrl = '';
  carouselIndex = 0;
  carouselPageSize = 4;

  constructor() { }

  ngOnInit(): void {
    this.carouselIndex = 0;
  }

  get visibleProducts(): SkuGroups[] {
    return this.products.slice(this.carouselIndex, this.carouselIndex + this.carouselPageSize);
  }

  get canScrollLeft(): boolean {
    return this.carouselIndex > 0;
  }

  get canScrollRight(): boolean {
    return this.carouselIndex + this.carouselPageSize < this.products.length;
  }

  carouselPrev() {
    if (this.canScrollLeft) this.carouselIndex--;
  }

  carouselNext() {
    if (this.canScrollRight) this.carouselIndex++;
  }

  onDisplayModeChange(mode: 'table' | 'list') {
    this.displayMode = mode;
  }

  onProductClick(product) {
    this.currentProductImageUrl = product.url;
    if (this.currentProductImageUrl) {
      this.changeShowProductImage();
    }
  }

  changeShowProductImage() {
    this.showProductImage = !this.showProductImage;
  }
}
